import { useForm } from '@mantine/form';

import { Departments } from '@/types';

type Props = {
  department: Departments;
};

export const useAddTgPageForm = ({ department }: Props) => {
  return useForm({
    initialValues: {
      name: '',
      username: '',
      phone: '',
      department,
    },

    validate: {
      name: (v) => (!v ? 'Name is required' : null),
      username: (v) => (!v ? 'Username is required' : null),
      phone: (v) => (!v ? 'Phone is required' : null),
      department: (v) => (!v ? 'Department is required' : null),
    },
  });
};
